import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM21 3h-3V1h-2v2H8V1H6v2H3v18h18V3zm-2 16H5V8h14v11z"
}), 'EventAvailableSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/EventAvailableSharp.js
// module id = 3412
// module chunks = 2